import { useState } from 'react';

import Card from '../../../components/Card';
import Radio from '../../../components/Radio';
import * as CardStyles from '../../../components/Card/Card.styles';

import TradingVolumeLargeCap from './TradingVolumeLargeCap';
import TradingVolumeMidCap from './TradingVolumeMidCap';
import TradingVolumeSmallCap from './TradingVolumeSmallCap';
import TradingVolumeMicroCap from './TradingVolumeMicroCap';
import TradingValueLargeCap from './TradingValueLargeCap';
import TradingValueMidCap from './TradingValueMidCap';
import TradingValueSmallCap from './TradingValueSmallCap';
import TradingValueMicroCap from './TradingValueMicroCap';

const chartViewOptions = [
  {
    value: 'klgd',
    label: 'Khối Lượng Giao Dịch',
  },
  {
    value: 'Giá Trị Giao Dịch',
    label: 'GTGD',
  },
];

export default function CapChart({
  tradingVolumeLargeCap,
  tradingVolumeMidCap,
  tradingVolumeSmallCap,
  tradingVolumeMicroCap,
  tradingValueLargeCap,
  tradingValueMidCap,
  tradingValueSmallCap,
  tradingValueMicroCap,
}) {
  const [chartViewOption, setChartViewOption] = useState(
    chartViewOptions[0].value
  );
  const handleTradingChange = (_value) => {
    setChartViewOption(_value);
  };

  const getTitle = () => {
    return (
      <div className="flex justify-between items-center cap-chart-header">
        <CardStyles.CardTitle>Thống Kê Theo Vốn Hóa</CardStyles.CardTitle>
        <div className="inline-flex">
          <Radio
            name="chartViewOption"
            options={chartViewOptions}
            defaultValue={chartViewOption || tradingOptions[0].value}
            onChange={handleTradingChange}
          />
        </div>
      </div>
    );
  };
  return (
    <Card customTitle={getTitle()}>
      <div className="mt-3">
        {chartViewOption === chartViewOptions[0].value ? (
          <div className="grid gap-6 grid-cols-1 md:grid-cols-2 xl:grid-cols-4 mt-6">
            <TradingVolumeLargeCap
              isLoading={tradingVolumeLargeCap.isTradingVolumeLargeCapLoading}
              historyCap={tradingVolumeLargeCap.tradingVolumeLargeCapData}
              isDarkMode={tradingVolumeLargeCap.isDarkMode}
              tradingVolumeChartType={
                tradingVolumeLargeCap.tradingVolumeChartType
              }
              setTradingVolumeChartType={
                tradingVolumeLargeCap.setTradingVolumeChartType
              }
              tradingVolumeExchangeHistoryChartData={
                tradingVolumeLargeCap.tradingVolumeExchangeHistoryChartData
              }
              selectedStock={tradingVolumeLargeCap.selectedStock}
            />
            <TradingVolumeMidCap
              isLoading={tradingVolumeMidCap.isTradingVolumeMidCapLoading}
              historyCap={tradingVolumeMidCap.tradingVolumeMidCapData}
              isDarkMode={tradingVolumeMidCap.isDarkMode}
              tradingVolumeChartType={
                tradingVolumeMidCap.tradingVolumeChartType
              }
              setTradingVolumeChartType={
                tradingVolumeMidCap.setTradingVolumeChartType
              }
              tradingVolumeExchangeHistoryChartData={
                tradingVolumeMidCap.tradingVolumeExchangeHistoryChartData
              }
              selectedStock={tradingVolumeMidCap.selectedStock}
            />
            <TradingVolumeSmallCap
              isLoading={tradingVolumeSmallCap.isTradingVolumeSmallCapLoading}
              historyCap={tradingVolumeSmallCap.tradingVolumeSmallCapData}
              isDarkMode={tradingVolumeSmallCap.isDarkMode}
              tradingVolumeChartType={
                tradingVolumeSmallCap.tradingVolumeChartType
              }
              setTradingVolumeChartType={
                tradingVolumeSmallCap.setTradingVolumeChartType
              }
              tradingVolumeExchangeHistoryChartData={
                tradingVolumeSmallCap.tradingVolumeExchangeHistoryChartData
              }
              selectedStock={tradingVolumeSmallCap.selectedStock}
            />
            <TradingVolumeMicroCap
              isLoading={tradingVolumeMicroCap.isTradingVolumeMicroCapLoading}
              historyCap={tradingVolumeMicroCap.tradingVolumeMicroCapData}
              isDarkMode={tradingVolumeMicroCap.isDarkMode}
              tradingVolumeChartType={
                tradingVolumeMicroCap.tradingVolumeChartType
              }
              setTradingVolumeChartType={
                tradingVolumeMicroCap.setTradingVolumeChartType
              }
              tradingVolumeExchangeHistoryChartData={
                tradingVolumeMicroCap.tradingVolumeExchangeHistoryChartData
              }
              selectedStock={tradingVolumeMicroCap.selectedStock}
            />
          </div>
        ) : (
          <div className="grid gap-6 grid-cols-1 md:grid-cols-2 xl:grid-cols-4 mt-6">
            <TradingValueLargeCap
              isLoading={tradingValueLargeCap.isTradingValueLargeCapLoading}
              historyCap={tradingValueLargeCap.tradingValueLargeCapData}
              isDarkMode={tradingValueLargeCap.isDarkMode}
              tradingValueChartType={tradingValueLargeCap.tradingValueChartType}
              setTradingValueChartType={
                tradingValueLargeCap.setTradingValueChartType
              }
              tradingValueExchangeHistoryChartData={
                tradingValueLargeCap.tradingValueExchangeHistoryChartData
              }
              selectedStock={tradingValueLargeCap.selectedStock}
            />
            <TradingValueMidCap
              isLoading={tradingValueMidCap.isTradingValueMidCapLoading}
              historyCap={tradingValueMidCap.tradingValueMidCapData}
              isDarkMode={tradingValueMidCap.isDarkMode}
              tradingValueChartType={tradingValueMidCap.tradingValueChartType}
              setTradingValueChartType={
                tradingValueMidCap.setTradingValueChartType
              }
              tradingValueExchangeHistoryChartData={
                tradingValueMidCap.tradingValueExchangeHistoryChartData
              }
              selectedStock={tradingValueMidCap.selectedStock}
            />
            <TradingValueSmallCap
              isLoading={tradingValueSmallCap.isTradingValueSmallCapLoading}
              historyCap={tradingValueSmallCap.tradingValueSmallCapData}
              isDarkMode={tradingValueSmallCap.isDarkMode}
              tradingValueChartType={tradingValueSmallCap.tradingValueChartType}
              setTradingValueChartType={
                tradingValueSmallCap.setTradingValueChartType
              }
              tradingValueExchangeHistoryChartData={
                tradingValueSmallCap.tradingValueExchangeHistoryChartData
              }
              selectedStock={tradingValueSmallCap.selectedStock}
            />
            <TradingValueMicroCap
              isLoading={tradingValueMicroCap.isTradingValueMicroCapLoading}
              historyCap={tradingValueMicroCap.tradingValueMicroCapData}
              isDarkMode={tradingValueMicroCap.isDarkMode}
              tradingValueChartType={tradingValueMicroCap.tradingValueChartType}
              setTradingValueChartType={
                tradingValueMicroCap.setTradingValueChartType
              }
              tradingValueExchangeHistoryChartData={
                tradingValueMicroCap.tradingValueExchangeHistoryChartData
              }
              selectedStock={tradingValueMicroCap.selectedStock}
            />
          </div>
        )}
      </div>
    </Card>
  );
}
